import Image from "next/image";

type DividerSize = "small" | "big" | "full";

export function Divider({ size = "big" }: { size?: DividerSize }) {
  let dividerUrl = "/img/DividerSmall.png";

  switch (size) {
    case "small":
      dividerUrl = "/img/DividerSmall.png";
      break;
    case "big":
      dividerUrl = "/img/DividerBig.png";
      break;
    case "full":
      dividerUrl = "/img/DividerFull.png";
      break;
  }

  return (
    <Image
      src={dividerUrl}
      width={0}
      height={0}
      sizes="100vh"
      alt={"Content Divider"}
      style={{
        width: "100%",
        height: "auto",
        objectFit: size === "full" ? "cover" : "none",
      }}
    />
  );
}
